class DeliveryMap {
    constructor() {
        this.ukMapSvg = document.querySelector('#United_Kingdom');

        this.mapKeyEls = Array.from(document.querySelectorAll('[data-ui-mapkey]'));

        if (this.ukMapSvg) {
            this.mainMapCounties = Array.from(this.ukMapSvg.querySelectorAll('#areapaths path'));
            this.londonCounties = Array.from(this.ukMapSvg.querySelectorAll('#london_insetareapaths path'));
            this.mapCounties = this.mainMapCounties.concat(this.londonCounties);
            this.mapTooltip = document.querySelector('.map-tooltip');
            this.init();
        }
    }

    init() {
        this.mapKeyEls.forEach((mapKeyEl) => {
            // Toggle svg map area highlight on when map key postcode is hovered
            mapKeyEl.addEventListener('mouseover', () => {
                const mapCounty = this.ukMapSvg.querySelector(`#${mapKeyEl.dataset.uiMapkey}_areapath`);
                if (mapCounty) {
                    mapCounty.classList.add('highlightarea');
                    this.showTooltip();
                    this.setTooltip(mapCounty.getBoundingClientRect().left + window.scrollX, mapCounty.getBoundingClientRect().top + window.scrollY, mapKeyEl.dataset.uiMapkey);
                }

                const mapCountyLdn = this.ukMapSvg.querySelector(`#${mapKeyEl.dataset.uiMapkey}london_insetareapath`);
                if (mapCountyLdn) {
                    mapCountyLdn.classList.add('highlightarea');
                }
            });

            // Toggle svg map area highlight off when map key postcode is hovered
            mapKeyEl.addEventListener('mouseleave', () => {
                const mapCounty = this.ukMapSvg.querySelector(`#${mapKeyEl.dataset.uiMapkey}_areapath`);
                if (mapCounty) {
                    this.hideTooltip();
                    mapCounty.classList.remove('highlightarea');
                }

                const mapCountyLdn = this.ukMapSvg.querySelector(`#${mapKeyEl.dataset.uiMapkey}london_insetareapath`);
                if (mapCountyLdn) {
                    mapCountyLdn.classList.remove('highlightarea');
                }
            });
        });

        this.mapCounties.forEach((county) => {
            county.addEventListener('mouseover', (e) => {
                let countyCode = county.id.split('_')[0];
                if (countyCode.indexOf('london') > 0) {
                    countyCode = countyCode.split('london')[0];
                }
                const mapKeyEl = document.querySelector(`[data-ui-mapkey="${countyCode}"]`);
                if (mapKeyEl) {
                    mapKeyEl.classList.add('highlight');
                }

                this.showTooltip();
                this.setTooltip(e.layerX, e.layerY, countyCode);
            });

            county.addEventListener('mouseleave', () => {
                let countyCode = county.id.split('_')[0];
                if (countyCode.indexOf('london') > 0) {
                    countyCode = countyCode.split('london')[0];
                }
                const mapKeyEl = document.querySelector(`[data-ui-mapkey="${countyCode}"]`);
                if (mapKeyEl) {
                    mapKeyEl.classList.remove('highlight');
                }

                this.hideTooltip();
            });
        });
    }

    setTooltip(x, y, text) {
        // Position and set content of tooltip
        this.mapTooltip.innerHTML = text;
        this.mapTooltip.style.top = `${y}px`;
        this.mapTooltip.style.left = `${x}px`;
    }

    hideTooltip() {
        this.mapTooltip.classList.add('hidden');
    }

    showTooltip() {
        this.mapTooltip.classList.remove('hidden');
    }
}

export default new DeliveryMap();



// WEBPACK FOOTER //
// ./src/js/modules/maps/delivery.js